import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Route, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})


export class CmsManagerGuard implements CanActivate {

  cmsManagerStatus:boolean= false;
  
  constructor(
    private CookieService: CookieService,
    private router : Router,
  ){
  
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.cmsManagerStatus = (this.CookieService.get('user_role') === 'cms_manager') ? true : false;

      if(this.cmsManagerStatus === true)
      {
        return true;
      }
      else
      {
        this.router.parseUrl('/');
        return false
        // return true;
      }
  }
  
}
